
import { useState } from 'react';



import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import sbilogo from "../images/sbi_logo.jpg";
import icicibanklogo from "../images/icici_bank logo.jpg";
import axixbanklogo from "../images/axix_bank logo.jpg";

import punjabnationalbank from "../images/PNB bank.jpg";
import centralbankofindia from "../images/central-bank-of-india-logo.jpg";
import barodabank from "../images/Bank of baroda.jpg";
import hdfcbanklogo from "../images/HDFC bank_logo.jpg";

import unionbanklogo from "../images/Union bank.jpg";
import bandhanbank_logo from "../images/Bandhan bank.jpg";
import canarabank_logo from "../images/Canara Bank.jpg";
import IDBIbank_logo from "../images/IDBI _bank logoo.jpg";

import indianoverseasbank_logo from "../images/Indian Overseas Bank.jpg";


import "./Clients.css";



function Clients() {


        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);

        const settings = {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 3
        };

        return (
                <div>



                        <div className="kanchraparapackersmoveers">
                                <br />
                                <div className='develop'>
                                        <center>
                                                <h1 style={{ color: "#ffffffff" }}><b>Our Clients</b></h1>
                                        </center>
                                </div>
                                <div className="animat">
                                        <Slider {...settings}>

                                                <div>

                                                        <div className="card mb-4 border-White box ">
                                                                <div className="reactjsdeveloper">

                                                                        <img src={sbilogo} className="card-img-top" alt="our clients_ SBI" />

                                                                </div>

                                                        </div>

                                                </div>

                                                <div>
                                                        <div className="card mb-4 border-White box ">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={icicibanklogo} className="card-img-top" alt="icicibanklogo" />

                                                                </div>
                                                        </div>
                                                </div>

                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={axixbanklogo} className="card-img-top" alt="axixbanklogo" />


                                                                </div>
                                                        </div>
                                                </div>

                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={punjabnationalbank} className="card-img-top" alt="punjabnationalbank" />
                                                                </div>
                                                        </div>
                                                </div>
                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={centralbankofindia} className="card-img-top" alt="centralbankofindia" />
                                                                </div>
                                                        </div>
                                                </div>
                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={barodabank} className="card-img-top" alt="bankofbaroda_our client" />
                                                                </div>
                                                        </div>
                                                </div>
                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={hdfcbanklogo} className="card-img-top" alt="HDFC Bank Our Client" />
                                                                </div>
                                                        </div>
                                                </div>
                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={unionbanklogo} className="card-img-top" alt="unionbanklogo"/>
                                                                </div>
                                                        </div>
                                                </div>
                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={bandhanbank_logo} className="card-img-top" alt="bandhanbank_logo"/>
                                                                </div>
                                                        </div>
                                                </div>

<div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={canarabank_logo} className="card-img-top" alt="canarabank_logo"/>
                                                                </div>
                                                        </div>
                                                </div>
                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={IDBIbank_logo} className="card-img-top" alt="IDBIbank_logo"/>
                                                                </div>
                                                        </div>
                                                </div>
                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <img src={indianoverseasbank_logo} className="card-img-top" alt="indianoverseasbank_logo"/>
                                                                </div>
                                                        </div>
                                                </div>




                                        </Slider>
                                </div>
                                <br />
                        </div>




                </div>
        )
}



export default Clients